import {validationRules} from './validationVariables';

export const validateField = (fields, name, value) => {
  if (Object.keys(fields.errors).length == 0) fields.errors = createErrorsObj(fields);

  fields.valid = '';

  fields[name] = value;
  const errors = {...fields['errors']};
  const rules = {...fields['rules']};

  if (rules[name] && rules[name] != undefined) errors[name] = validateByRules(value, rules[name]);
  else {
    errors[name] = validate(name, value);
  }

  fields['errors'] = errors;

  return fields;
};

export const validateFieldMultiple = (form, id, value, ruleName) => {
  if (Object.keys(form.multipleErrors).length == 0) form.multipleErrors = createErrorsForMultipleObj(form, id);

  form.valid = '';

  const multipleErrors = {...form['multipleErrors']};
  const rules = {...form['rules']};

  if (rules[ruleName] && rules[ruleName] != undefined) multipleErrors[id] = validateByRules(value, rules[ruleName]);
  else {
    multipleErrors[id] = validate(ruleName, value);
  }

  form.phones[id].value = value;
  form['multipleErrors'] = multipleErrors;

  return form;
};

export const validateValue = (rules, name, value) => {
  let error = '';

  if (rules && rules != undefined) {
    error = validateByRules(value, rules);
  } else {
    error = validate(name, value);
  }

  return error;
};

export const validateFields = (fields) => {
  if (Object.keys(fields.errors).length == 0) fields.errors = createErrorsObj(fields);

  let err = '';
  let errCounter = 0;
  fields.valid = '';

  const rules = {...fields['rules']};

  for (let item in fields) {
    if (item != 'valid' && item != 'errors' && item != 'rules') {
      if (rules[item] && rules[item] != undefined) {
        err = validateByRules(fields[item], rules[item]);
        if (err.length > 1) errCounter++;
      } else {
        err = validate(item, fields[item]);
        if (err.length > 1) errCounter++;
      }

      fields.errors[item] = err;
    }
  }

  if (errCounter > 0) fields['valid'] = false;
  else fields['valid'] = true;

  return fields;
};

const createErrorsObj = (fields) => {
  for (let item in fields) {
    if (item != 'valid' && item != 'errors' && item != 'rules') {
      fields.errors[item] = '';
    }
  }

  return fields.errors;
};

const createErrorsForMultipleObj = (form, currentId) => {
  for (let phone in form.phones) {
    form.multipleErrors[phone] = '';
  }

  return form.multipleErrors;
};

const validateByRules = (val, rules) => {
  let err = '';

  for (let rule in rules) {
    switch (rule) {
      case 'required':
        validateRequired(val) ? (err = rules['required'].error) : (err = '');
        break;
      case 'pattern':
        validatePattern(val, rules['pattern'].value) ? (err = '') : (err = rules['pattern'].error);
        break;
      case 'minLength':
        validateMinLength(val, rules['minLength'].value) ? (err = '') : (err = rules['minLength'].error);
        break;
      case 'maxLength':
        validateMaxLength(val, rules['maxLength'].value) ? (err = '') : (err = rules['maxLength'].error);
        break;
      case 'maxFileSize':
        validateFileSize(val, rules['maxFileSize'].value) ? (err = '') : (err = rules['maxFileSize'].error);
        break;
      case 'checkboxRequired':
        validateCheckboxRequired(val, rules['checkboxRequired'].value) ? (err = '') : (err = rules['checkboxRequired'].error);
        break;
    }
    if (err != '') return err;
  }

  return err;
};

const validate = (name, val) => {
  let err = '';
  var rules = {};

  switch (name) {
    case 'city':
      rules = validationRules.onlyRequired;
      break;
    case 'home':
      rules = validationRules.onlyRequired;
      break;
    case 'street':
      rules = validationRules.onlyRequired;
      break;
    case 'userName':
      rules = validationRules.userName;
      break;
    case 'fullName':
      rules = validationRules.fullName;
      break;
    case 'phone':
      rules = validationRules.phone;
      break;
    case 'phoneStationaryAccepted':
      rules = validationRules.phoneStationaryAccepted;
      break;
    case 'CardNumber':
      rules = validationRules.CardNumber;
      break;
    case 'CardDueYear':
      rules = validationRules.CardDueYear;
      break;
    case 'CardDueMonth':
      rules = validationRules.CardDueMonth;
      break;
    case 'CVV':
      rules = validationRules.CVV;
      break;
    case 'id':
      rules = validationRules.id;
      break;
    case 'email':
      rules = validationRules.email;
      break;
    case 'file':
      rules = validationRules.file;
    case 'imei':
      rules = validationRules.imei;
      break;

    //default:rules = validationRules.onlyRequired;
  }

  for (let rule in rules) {
    switch (rule) {
      case 'required':
        validateRequired(val) ? (err = rules['required'].error) : (err = '');
        break;
      case 'pattern':
        validatePattern(val, rules['pattern'].value) ? (err = '') : (err = rules['pattern'].error);
        break;
      case 'minLength':
        validateMinLength(val, rules['minLength'].value) ? (err = '') : (err = rules['minLength'].error);
        break;
      case 'maxLength':
        validateMaxLength(val, rules['maxLength'].value) ? (err = '') : (err = rules['maxLength'].error);
        break;
      case 'maxFileSize':
        validateFileSize(val, rules['maxFileSize'].value) ? (err = '') : (err = rules['maxFileSize'].error);
        break;
      case 'identity':
        validateIsraeliID(val) ? (err = '') : (err = rules['identity'].error);
        break;
      case 'checkboxRequired':
        validateCheckboxRequired(val) ? (err = rules['checkboxRequired'].error) : (err = '');
        break;
    }

    if (err != '') return err;
  }

  return err;
};

const validateIsraeliID = (id) => {
  return (
    /\d{9}/.test(id) &&
    !id.match(/^0*$/) &&
    Array.from(id, Number).reduce((counter, digit, i) => {
      const step = digit * ((i % 2) + 1);
      return counter + (step > 9 ? step - 9 : step);
    }) %
      10 ===
      0
  );
};


const validateRequired = (value) => {
  if (value != undefined) return value.toString().trim() === '';

  return true;
};

const validateMinLength = (value, minLength) => {
  return value.length >= minLength;
};

const validateMaxLength = (value, maxLength) => {
  return value.length <= maxLength;
};

const validateFileSize = (value, maxSize) => {
  return value <= maxSize;
};

const validatePattern = (value, pattern) => {
  let re = new RegExp(pattern);
  var test = re.test(String(value).toLowerCase());
  return re.test(String(value).toLowerCase());
};

const validateCheckboxRequired = (value) => {
  return !!value;
};
